export default "__VITE_ASSET__DT1ALom$__"